<div v-if="total > 0" ref="relReviewsList" class="tt-c-related-reviews-list">
  <div class="tt-c-related-reviews-list__header tt-u-mb--md">
    <div ref="headingText" class="tt-c-related-reviews-list__heading" role="heading" :aria-level="heading.level" tabindex="-1" v-html="heading.text"></div>
  </div>

  <div class="tt-c-related-reviews-list__content">
    <template v-if="showFullReview">
      <tt-review v-for="review in reviews"
                  @openMediaModal="openMediaModal"
                  @translateReview="translateReview"
                  :allItemsInLayout="allItemsInLayout"
                  :currentLayout="currentLayout"
                  :enableFrontEndReviewTranslation="reviewsListConfig.enableFrontEndReviewTranslation"
                  :headingLevel="heading.level + 1"
                  :isRelatedReview="true"
                  :mediaSize="mediaSize"
                  :review="review"
                  :slotNamesAfterShowDetails="slotNamesAfterShowDetails"
                  :truncateLength="truncateLength"
                  :key="review.id"></tt-review>
    </template>
  </div>

  <div v-if="reviewsListConfig.useShowMore" class="tt-c-related-reviews-list__show-more">
    <div v-show="showMoreDisabled" class="tt-o-spinner"></div>
    <tt-button v-show="!showMoreDisabled && hasMore" @click="showMore" type="primary" class="tt-c-related-reviews-list__show-more-btn" v-html="$msg('relatedReviewsList.showMore')"></tt-button>
  </div>
  <tt-pagination v-else-if="!reviewsListConfig.useShowMore"
                 @updatePage="pageChange"
                 :currentPage="currentPage"
                 :contentType="$msg('relatedReviewsList.header')"
                 :total="total"
                 :initialPageSize="initialPageSize"
                 :pageSize="pageSize"></tt-pagination>
</div>
